import Navbar from './Navbar';

export default function Sidebar () {
    return (
        <div className="side-bar">
            <Navbar />
      </div>
    )
}